import React, {useState} from 'react'
import { Typography, TextField, Button, Modal, Box } from "@mui/material";

const AddScheduleModal = ({open, schedule, onClose, onSave}) => {
 const [name, setName] =  useState(schedule.name || "");

 const handleSaveNewSchedule = () => {
    const newSchedule = { ...schedule, name };
    onSave(newSchedule);
 }
  return (
    <div> <Modal
    open={open}
    onClose={onClose}
  >
    <Box
      sx={{
        width: 400,
        margin: "auto",
        padding: 3,
        marginTop: 8,
        backgroundColor: "white",
        borderRadius: 2,
      }}
    >
      <Typography variant="h6">Add New Schedule</Typography>

      <TextField
        fullWidth
        label="Title"
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
        sx={{ my: 2 }}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={handleSaveNewSchedule}
        sx={{ mr: 1 }}
      >
        Save
      </Button>
      <Button
        variant="outlined"
        onClick={onClose}
      >
        Cancel
      </Button>
    </Box>
  </Modal></div>
  )
}

export default AddScheduleModal